'use strict';
angular.module('pmtPlacesApp.controllers').controller('AuditCtrl', [
	'$scope',
	'$http',
	'$stateParams',
	'$q',
	'pmtEnabledNetworksService',
	'$i18next',
	'auth',
	function ($scope, $http, $stateParams, $q, pmtEnabledNetworksService, $i18next, auth) {
		Object.assign($scope, pmtEnabledNetworksService.get(this.site));
		$scope.isPinMeToDeveloper = auth.getUserRoles().includes('pinmetodeveloper');

		const locale = auth.user.settings.locale || 'browser';

		$scope.dateLocaleFormatted = date => {
			return new Date(date).toLocaleString(locale, {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric'
			});
		};

		$scope.expandedItems = {
			itemHistory: {},
			schedule: {},
			network: [{}]
		};

		$scope.expandedLocations = false;

		$scope.sortingItems = {
			sortingItemsHeaders: {
				action: false,
				date: true,
				'user.name': false,
				'delta[0].path': false
			},
			sortingItemsSchedule: {
				action: true,
				date: true,
				'user.name': true
			},
			sortingItemsNetwork: {
				action: true,
				date: true,
				'user.name': true,
				'delta[0].path': true
			}
		};

		$scope.beforeDataNotLoaded = [];
		$scope.scheduleDataNotLoaded = true;
		$scope.arrayOfBeforeObjects = [[[{}]]];
		$scope.arrayOfAfterObjects = [[[{}]]];
		$scope.arrayOfScheduleObjects = [[{}]];

		$scope.saveObjectsNetworks = function (data, index) {
			if ($scope.beforeDataNotLoaded[index] === undefined) {
				$scope.beforeDataNotLoaded[index] = true;
			}
			if ($scope.beforeDataNotLoaded[index]) {
				if (data.length > 0) {
					$scope.beforeDataNotLoaded[index] = false;
					$scope.saveBeforeObjectValues(data, index);
					$scope.saveAfterObjectValues(data, index);
				}
			}
		};

		$scope.saveObjectsSchedule = function (data) {
			if ($scope.scheduleDataNotLoaded) {
				if (data.length > 0) {
					$scope.scheduleDataNotLoaded = false;
					$scope.saveScheduleObjectValues(data);
				}
			}
		};

		$scope.saveBeforeObjectValues = function (data, index) {
			$scope.arrayOfBeforeObjects[index] = [];
			for (let i = 0; i < data.length; i++) {
				$scope.arrayOfBeforeObjects[index][i] = [];
				for (let j = 0; j < data[i].delta.length; j++) {
					$scope.arrayOfBeforeObjects[index][i][j] = {};
					let json = $scope.parseJsonString($scope.getStartValue(data[i].delta[j]));
					if (typeof json === 'object' && json !== undefined && json !== null) {
						$scope.arrayOfBeforeObjects[index][i][j] = json;
					}
				}
			}
		};

		$scope.saveAfterObjectValues = function (data, index) {
			$scope.arrayOfAfterObjects[index] = [];
			for (let i = 0; i < data.length; i++) {
				$scope.arrayOfAfterObjects[index][i] = [];
				for (let j = 0; j < data[i].delta.length; j++) {
					$scope.arrayOfAfterObjects[index][i][j] = {};
					let json = $scope.parseJsonString($scope.getNewValue(data[i].delta[j]));
					if (typeof json === 'object' && json !== undefined && json !== null) {
						$scope.arrayOfAfterObjects[index][i][j] = json;
					}
				}
			}
		};

		$scope.saveScheduleObjectValues = function (dataS) {
			for (let i = 0; i < dataS.length; i++) {
				$scope.arrayOfScheduleObjects[i] = [];
				for (let j = 0; j < dataS[i].changes.data.length; j++) {
					$scope.arrayOfScheduleObjects[i][j] = {};
					let json = $scope.parseJsonString(dataS[i].changes.data[j].value);
					if (typeof json === 'object' && json !== undefined && json !== null) {
						$scope.arrayOfScheduleObjects[i][j] = json;
					}
				}
			}
		};

		$scope.parseJsonString = function (jsonData) {
			try {
				return JSON.parse(jsonData);
			} catch {
				return null;
			}
		};
		const hasUndefinedValue = (a, b) => a === undefined || b === undefined;

		const getNestedValue = (obj, key) => {
			if (key.includes('[')) {
				const arrayName = key.split('[')[0];
				const arrayIndex = key.match(/\[(.*?)\]/)[1];
				return obj[arrayName]?.[arrayIndex];
			}
			return obj[key];
		};

		const toDateIfDateString = value =>
			typeof value === 'string' && !isNaN(Date.parse(value)) ? new Date(value) : value;

		function compareValues(a, b, key, sortDirection) {
			for (const k of key.split('.')) {
				a = getNestedValue(a, k);
				b = getNestedValue(b, k);
				if (hasUndefinedValue(a, b)) {break;}
			}

			a = toDateIfDateString(a);
			b = toDateIfDateString(b);

			if (hasUndefinedValue(a, b)) {return 0;}

			return sortDirection === 'ascending'
				? a < b
					? -1
					: a > b
						? 1
						: 0
				: a < b
					? 1
					: a > b
						? -1
						: 0;
		}

		$scope.sortItems = function (items, table, key, direction) {
			items.sort((a, b) => compareValues(a, b, key, direction));
			$scope.sortingItems[table][key] = !$scope.sortingItems[table][key];
		};

		$scope.isObjectTypeWithLength = function (value) {
			return typeof value === 'object' && value !== null;
		};

		$scope.determineDisplayType = function (diff = {}) {
			const checkMaps_ = [
				{ check: () => diff.path === 'hours', type: 'hours' },
				{ check: () => diff.path === 'openHours', type: 'openHours' },
				{
					check: () =>
						diff.path === 'specialOpenHours' || diff.path === 'google.data.specialOpenHours',
					type: 'specialOpenHours'
				},
				{
					check: () =>
						diff.path === 'networkAttributes.google' || diff.path === 'google.data.attributes',
					type: 'googleAttributes'
				},
				{ check: () => diff.path === 'networkServiceItems.google', type: 'googleServiceItems' },
				{
					check: () => diff.path === 'temporarilyClosedUntil' && diff.value === '',
					type: 'temporarilyClosedUntil empty value'
				},
				{
					check: () => $scope.checkIfIsJson(diff.value) !== -1,
					type: 'json'
				},
				{
					check: () => $scope.isBooleanNumberOrString(diff.value),
					type: 'booleanNumberOrString'
				},
				{
					check: () =>
						$scope.isObjectTypeWithLength(diff.value) &&
						diff.value.length &&
						diff.value.every(v => $scope.isBooleanNumberOrString(v)),
					type: 'arrayOfStrings'
				},
				{ check: () => true, type: 'object' }
			];

			for (const { check, type } of checkMaps_) {
				if (check()) {
					return type;
				}
			}
		};

		$scope.filterItemsByStartDate = function (items, comparisonDateString) {
			let comparisonDate = new Date(comparisonDateString);
			comparisonDate.setHours(0, 0, 0, 0);

			let filteredItems = items.filter(function (item) {
				if (!item.hasOwnProperty('start')) {
					return true;
				}

				let startDate = new Date(item.start);
				return startDate >= comparisonDate;
			});

			filteredItems.sort(function (a, b) {
				let dateA = new Date(a.start);
				let dateB = new Date(b.start);
				return dateA - dateB;
			});

			return filteredItems;
		};

		$scope.getFirstPathValue = function (path) {
			if (Array.isArray(path)) {
				return path[0];
			}
			return null;
		};
		$scope.isNotObject = function (value) {
			return typeof value !== 'object';
		};
		$scope.isBooleanNumberOrString = function (value) {
			return typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string';
		};
		$scope.toDisplayString = function (value) {
			let str = '';
			if (typeof value === 'boolean') {
				str = value ? 'true' : 'false';
			} else if (value === '' || value === '[object Object]') {
				str = '-';
			} else {
				str = String(value);
			}
			str.replace('{"', '').replace('"}', '').replace('{"', '').replace('"]', '');
			return str;
		};

		$scope.formatCellValue = function (value) {
			if (value === null || value === undefined || value === '') {
				return '-';
			}
			if (typeof value === 'object') {
				if (typeof value.longName === 'string') {
					return value.longName;
				}
				return JSON.stringify(value);
			}
			if (typeof value === 'string' && value.indexOf('00:00') !== -1) {
				return new Date(value).toISOString().slice(0, 10);
			}
			return $scope.toDisplayString(value);
		};

		// Function to toggle the expanded state
		$scope.toggleExpandLocations = function () {
			$scope.expandedLocations = !$scope.expandedLocations;
		};

		// Function to check if the list is expanded
		$scope.isExpandedLocations = function () {
			return $scope.expandedLocations;
		};

		$scope.toggleExpand = function (parentIndex, index, tableName, networkNo, changeNumber) {
			if (networkNo === -1) {
				$scope.expandedItems[tableName][parentIndex][index] =
					!$scope.expandedItems[tableName][parentIndex][index];
			} else {
				$scope.expandedItems[tableName][networkNo][parentIndex][index][changeNumber] =
					!$scope.expandedItems[tableName][networkNo][parentIndex][index][changeNumber];
			}
		};

		$scope.isExpanded = function (parentIndex, index, tableName, networkNo, changeNumber) {
			if (networkNo === -1) {
				$scope.expandedItems[tableName][parentIndex] =
					$scope.expandedItems[tableName][parentIndex] || [];
				if ($scope.expandedItems[tableName][parentIndex][index] === undefined) {
					$scope.expandedItems[tableName][parentIndex][index] = false;
				}
				return $scope.expandedItems[tableName][parentIndex][index];
			} else {
				$scope.expandedItems[tableName][networkNo] =
					$scope.expandedItems[tableName][networkNo] || [];
				$scope.expandedItems[tableName][networkNo][parentIndex] =
					$scope.expandedItems[tableName][networkNo][parentIndex] || [];
				$scope.expandedItems[tableName][networkNo][parentIndex][index] =
					$scope.expandedItems[tableName][networkNo][parentIndex][index] || [];
				if (
					$scope.expandedItems[tableName][networkNo][parentIndex][index][changeNumber] === undefined
				) {
					$scope.expandedItems[tableName][networkNo][parentIndex][index][changeNumber] = false;
				}
				return $scope.expandedItems[tableName][networkNo][parentIndex][index][changeNumber];
			}
		};

		$scope.filterActionLinksChangedBySystem = auditItem => {
			const firstPath = auditItem.delta?.[0]?.path;
			if (!firstPath) {return true;}

			return !(
				(auditItem.user.name === 'System ' &&
					(firstPath === 'actionLinks' || firstPath === 'networkActionLinks.google')) ||
				firstPath === 'google.validation.hasDataDiff'
			);
		};

		$scope.dataTitle = input => {
			if (!input || typeof input !== 'string') {
				return '';
			}
			let text1 = input.split('.')[0].charAt(0).toUpperCase() + input.split('.')[0].slice(1);
			let text2 = $scope.capitalize(text1).replace('_', '');

			return text2;
		};

		$scope.checkIfIsJson = input => {
			if (typeof input === 'string' && input.includes('[{')) {
				try {
					const parsed = JSON.parse(input);
					if (parsed.length > 0) {
						return parsed.length;
					} else {
						return -1;
					}
				} catch {
					return -1;
				}
			}
			return -1;
		};
		$scope.capitalize = input => {
			if (typeof input === 'string') {
				let text = input.replace(/([A-Z])/g, ' $1').trim();
				return text;
			}
			return '';
		};

		$scope.checkKeysObject = input => {
			if (input) {
				try {
					const numOfKeys = Object.keys(input).length;
					if (numOfKeys > 0) {
						return numOfKeys;
					} else {
						return -1;
					}
				} catch {
					return -1;
				}
			}
			return -1;
		};

		$scope.arrayDecompose = input => {
			if (typeof input === 'string') {
				let text = input.replace('[', '').replace(']', '').replace('"', '').replace(',', ', ');
				return text;
			}
			return '';
		};

		$scope.scheduleFormat = input => {
			if (typeof input === 'string') {
				let text = input.replace('[', '-').replace(']', '').replace('Open Hours ', '');
				return text;
			}
			return '';
		};

		$scope.addSpacingChanges = input => {
			if (typeof input === 'string') {
				let text = input.replace('_', '');
				let text2 = $scope.weekdaysChangeName(text);
				let text3 = text2.charAt(0).toUpperCase() + text2.slice(1);
				let text4 = $scope.capitalize(text3);
				text4 += ' ';
				return text4;
			}
			return '';
		};

		$scope.isEmptyArrayValue = value => {
			return Array.isArray(value) && value.length === 0 ? '-' : '';
		};
		$scope.isEmptyValue = value => {
			return value === null || value === undefined ? '-' : '';
		};

		$scope.priceObjectToString = input => {
			if (typeof input === 'object') {
				return `${input.amount} ${input.currencyCode}`;
			}
			return '-';
		};

		$scope.weekdaysChangeName = input => {
			if (typeof input === 'string') {
				let text = input
					.replace('mon', ' Monday')
					.replace('tue', ' Tuesday')
					.replace('wed', ' Wednesday')
					.replace('thu', ' Thursday')
					.replace('fri', ' Friday')
					.replace('sat', ' Saturday')
					.replace('sun', ' Sunday');
				return text;
			}
			return '';
		};

		const site = $stateParams.site,
			placeId = $stateParams.placeId,
			auditMap = [{ network: 'pinmeto' }, { network: 'schedule' }];

		if ($scope.facebookEnabled) {
			auditMap.push({ name: 'Facebook', network: 'facebook', collapsed: true });
		}
		if ($scope.googleEnabled) {
			auditMap.push({ name: 'Google', network: 'google', collapsed: true });
		}
		if ($scope.bingEnabled) {
			auditMap.push({ name: 'Bing', network: 'bing', collapsed: true });
		}
		if ($scope.appleEnabled) {
			auditMap.push({ name: 'Apple', network: 'apple', collapsed: true });
		}
		if ($scope.ptvEnabled && $scope.isPinMeToDeveloper) {
			auditMap.push({ name: 'PTV', network: 'ptv', collapsed: true });
		}
		$scope.loading = true;

		$scope.getStartValue = diff => {
			if (diff && diff.item && diff.item.lhs) {
				return JSON.stringify(diff.item.lhs);
			} else if (diff && diff.lhs) {
				return diff.lhs.toString();
			} else {
				return '';
			}
		};

		$scope.getNewValue = diff => {
			if (diff && diff.item && diff.item.rhs) {
				return JSON.stringify(diff.item.rhs);
			} else if (diff && diff.rhs) {
				return typeof diff.rhs === 'object' ? JSON.stringify(diff.rhs) : diff.rhs.toString();
			} else {
				return '';
			}
		};

		function getAudit(audit) {
			let deferred = $q.defer();
			let url = `api/${encodeURI(site)}/place/${placeId}/audit`;
			if (audit.network === 'schedule') {
				url = `api/${encodeURI(site)}/place/${placeId}/schedule/audit`;
			} else if (audit.network !== 'pinmeto') {
				url = `${url}/${audit.network}`;
			}
			$http
				.get(url)
				.then(response => {
					if (audit.network === 'pinmeto') {
						$scope.itemAudit = response.data.flatMap(({ delta, ...itemRest }) => {
							if (delta?.length > 1) {
								return delta.map(d => ({ delta: [d], ...itemRest }));
							}
							return { delta, ...itemRest };
						});
					} else if (audit.network === 'schedule') {
						$scope.scheduleUpdates = response.data.map(update => {
							if (update.action === 'create') {
								update.title = $i18next.t('listings.audit_log.schedule_update_created', {
									field:
										update.fieldToUpdate === 'openHours'
											? $i18next.t('general.location_open_hours')
											: '',
									date: update.date
								});
							} else if (update.action === 'delete') {
								update.title = $i18next.t('listings.audit_log.schedule_update_deleted', {
									field:
										update.fieldToUpdate === 'openHours'
											? $i18next.t('general.location_open_hours')
											: '',
									date: update.date
								});
							}
							return update;
						});
					}

					audit.data = response.data;
					deferred.resolve(audit);
				})
				.catch(err => deferred.reject(err));
			return deferred.promise;
		}

		$q.all(auditMap.map(getAudit)).then(auditMap_ => {
			$scope.auditMap = auditMap_.filter(x => x.network !== 'pinmeto' && x.network !== 'schedule');
			$scope.loading = false;
		});
	}
]);
